import React, { useState, useEffect, useRef } from 'react';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { uploadData } from 'aws-amplify/storage';
import awsconfig from '../aws-exports';
import { getUserByUsernameWithProjects } from '../custom_queries'; // Importa tu consulta personalizada
import './UploadPage.css';
import { Text, Loader, Badge, Grid, TextField, Button, Icon, Input, useTheme, Table, TableHead, TableCell, TableRow, TableBody, Radio, Message } from '@aws-amplify/ui-react';
import { MdOutlineRemoveCircleOutline } from 'react-icons/md';


Amplify.configure(awsconfig);

const client = generateClient();

const updateProjectMutation = /* GraphQL */ `
  mutation UpdateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      id
      name
      path
      metadata
      mapping
      createdAt
      updatedAt
    }
  }
`;

function UploadPage(props) {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedProjectPath, setSelectedProjectPath] = useState('');
  const [selectedProjectMetadata, setSelectedProjectMetadata] = useState(true);
  const [metadataMappings, setMetadataMappings] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [Role, setRole] = useState('Cliente');
  const [adminMessage, setAdminMessage] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isTemporal, setIsTemporal] = useState(true);
  const [temporalComponent, setTemporalComponent] = useState();
  const [columnNameAudio, SetColumnNameAudio] = useState('');
  const [columnNameAudioId, SetColumnNameAudioId] = useState('');
  const [clientColumns, setClientColumns] = useState({});

  const mappingsRef = useRef({});
  const { tokens } = useTheme();

  const handlerLoader = () => {
    setTimeout(() => {
      setIsTemporal(false);
    }, 4000);

    setTemporalComponent(
      <Loader
        variation="linear"
        emptyColor={tokens.colors.gray}
        filledColor={'#588292'}
      />)
  }

  const handlerTemporal = (type) => {
    if (type === 'loader') {
      handlerLoader();
    }
  }

  useEffect(() => {
    handlerTemporal("loader");
    fetchProjects();
    setRole(props.role);
  }, []);

  const fetchProjects = async () => {
    try {
      const currentUser = await getCurrentUser();
      const username = currentUser.username;

      const userProjectsData = await client.graphql({
        query: getUserByUsernameWithProjects,
        variables: { username }
      });

      if (userProjectsData.data.getUserByUsername.items.length > 0) {
        const user = userProjectsData.data.getUserByUsername.items[0];
        setIsAdmin(user.isAdmin);
        const projects = user.projects.items.map(item => item.project);
        setProjects(projects);
      } else {
        setProjects([]);
      }
    } catch (error) {
      console.log('Error fetching projects:', error);
      setProjects([]);
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    setSelectedProject(projectId);
    const project = projects.find(p => p.id === projectId);
    setSelectedProjectPath(project ? project.path : '');
    setSelectedProjectMetadata(project ? project.metadata : true);
    try {
      // Analizar y transformar mapping
      const mappingsString = project && project.mapping ? project.mapping : '{}';
      const mappings = JSON.parse(mappingsString);
      const newMappings = Object.entries(mappings).map(([key, value]) => ({
        id: `${Date.now()}-${Math.random()}`,
        key,
        client_column: value.client_column,
        client_possible_values: value.client_possible_values || '',
        column_name_audio: value.column_name_audio || ''
      }));
      setMetadataMappings(newMappings);

      if (newMappings.length > 0) {
        for (let map of newMappings) {
          if (map.hasOwnProperty("column_name_audio") && map.column_name_audio === map.client_column){
            SetColumnNameAudioId(map.id)
            SetColumnNameAudio(map.column_name_audio);
          }
        }

      }
      mappingsRef.current = newMappings.reduce((acc, mapping) => {
        acc[mapping.id] = mapping;
        return acc;
      }, {});
    } catch (error) {
      console.error("Error parsing mappings:", error);
      setMetadataMappings([]);
      mappingsRef.current = {};
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setShowModal(true);
    setTimeout(() => setShowModal(false), 5000);

    const newMappings = metadataMappings.reduce((acc, mapping) => {
      const keyElement = document.getElementById(`key-${mapping.id}`);
      const clientColumnElement = document.getElementById(`client-column-${mapping.id}`);
      const possibleValuesElement = document.getElementById(`possible-values-${mapping.id}`);
      acc[keyElement.value] = {
        client_column: clientColumnElement.value,
        client_possible_values: isAdmin ? possibleValuesElement.value : '',
        column_name_audio: columnNameAudio
      };
      return acc;
    }, {});

    if (file && selectedProject) {
      try {
        setMessage('Estado: Subiendo archivo...');
        const fileName = `public/${selectedProject}/${file.name}`;
        const result = await uploadData({
          path: fileName,
          data: file,
          options: {
            onProgress: ({ transferredBytes, totalBytes }) => {
              if (totalBytes) {
                const percentage = Math.round((transferredBytes / totalBytes) * 100);
                setUploadProgress(percentage);
              }
            }
          }
        }).result;

        setMessage('Estado: Archivo subido con éxito, validando...');
        setIsValidating(true);
        const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
        const apiBody = JSON.stringify({
          bucket: awsconfig.aws_user_files_s3_bucket,
          key: result.path,
          efs_path: selectedProjectPath,
          metadata: selectedProjectMetadata,
          mapping: newMappings
        });
        // const url = 'https://a77uuc2w4k2yrp2xdimr43crua0kgrjc.lambda-url.us-east-2.on.aws/' //dev
        const url = 'https://wlyjrniajk35cgue3v4mbrohlq0uecuf.lambda-url.us-east-2.on.aws/' //prod
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'content-Type': 'application/json',
            'authorization': authToken
          },
          body: apiBody
        });
        const resultJson = await response.json();
        setIsValidating(false);
        if (resultJson.success) {
          setMessage('Validación y envío al SFTP exitosos.');
        } else {
          setMessage(`Errores encontrados: ${resultJson.errors.join(', ')}`);
        }
      } catch (error) {
        console.log('Error : ', error);
        setIsValidating(false);
        setMessage(`Error al subir el archivo: ${error.message}`);
      }
    } else {
      setMessage('Por favor, selecciona un archivo y un proyecto.');
    }
  };

  const saveMappings = async () => {
    const newMappings = metadataMappings.reduce((acc, mapping) => {
      const keyElement = document.getElementById(`key-${mapping.id}`);
      const clientColumnElement = document.getElementById(`client-column-${mapping.id}`);
      const possibleValuesElement = document.getElementById(`possible-values-${mapping.id}`);
      acc[keyElement.value] = {
        client_column: clientColumnElement.value,
        client_possible_values: isAdmin ? possibleValuesElement.value : '',
        column_name_audio: columnNameAudio
      };
      return acc;
    }, {});

    try {
      await client.graphql({
        query: updateProjectMutation,
        variables: {
          input: {
            id: selectedProject,
            mapping: JSON.stringify(newMappings)
          }
        }
      });
      setMessage('Mappings guardados con éxito.');
      setTimeout(() => setMessage(''), 5000);
    } catch (error) {
      console.error('Error guardando mappings:', error);
      setMessage(`Error guardando mappings: ${error.message}`);
      setTimeout(() => setMessage(''), 5000);
    }
  };

  const addMapping = () => {
    const newId = `${Date.now()}-${Math.random()}`;
    const newMapping = { id: newId, key: '', client_column: '', client_possible_values: '' , column_name_audio: ''};
    setMetadataMappings([...metadataMappings, newMapping]);
    mappingsRef.current[newId] = newMapping;
  };

  const removeMapping = (id) => {
    if (id === columnNameAudioId) {
      SetColumnNameAudioId('');
      SetColumnNameAudio('');
    }
    const newMappings = metadataMappings.filter(mapping => mapping.id !== id);
    setMetadataMappings(newMappings);
    delete mappingsRef.current[id];
  };

  const handleInputClick = () => {
    if (!isAdmin) {
      setAdminMessage('Solo los administradores pueden modificar los mapeos.');
      setTimeout(() => {
        setAdminMessage('');
      }, 5000);
    }
  };

  const radioChange = (mapping) => {
    const clientColumnValue = clientColumns[mapping.id];
    if (clientColumnValue){
      SetColumnNameAudioId(mapping.id)
      SetColumnNameAudio(clientColumnValue);
    } else {
      SetColumnNameAudioId(mapping.id)
      SetColumnNameAudio(mapping.client_column);
    }
    setTimeout(() => setMessage(''), 5000);
  };

  const radioChangeReal = (value, mapping) => {
    setClientColumns(prevState => ({
      ...prevState,
      [mapping.id]: value,  // Guarda el valor de client_column en el estado
    }));
    setTimeout(() => setMessage(''), 5000);
    if (columnNameAudioId === mapping.id) {
      SetColumnNameAudio(value);
      setTimeout(() => setMessage(''), 5000);
    }
  }

  return (
    <div className="container">
      {isTemporal ? (
        <div className="container">
          <Grid
            templateColumns="10fr"
            templateRows="12rem"
          >
            <div>
              <h1>  Cargar Archivos </h1>
            </div>
            {temporalComponent}
          </Grid></div>) : (
        <div className='container-cargar'>
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <p>No cierre la ventana hasta que la carga esté completa.</p>
          </div>
        </div>
      )}
      {projects.length === 0 ? (
        <p className="error">No tiene proyectos asignados, comuníquese con el área de soporte de Ressolve para asignarle uno</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <select onChange={handleProjectChange} value={selectedProject}>
            <option value="">Selecciona un proyecto</option>
            {projects.map((project) => (
              <option key={project.id} value={project.id}>
                {project.name}
              </option>
            ))}
          </select>

          {selectedProject && (
            <>
            { Role!=='Cliente' &&
              <TextField
                variation="quiet"
                size="small"
                descriptiveText="Ruta del proyecto"
                defaultValue={selectedProjectPath}
                className='selected-project'
                isDisabled
              />}
              <div className='container'>
                <div className='mapping-container-2'>
                  <Table
                    caption=""
                    highlightOnHover={false}
                    size="small"
                    variation="striped">
                    <TableHead>
                      <TableRow>
                        <TableCell as="th">Datos ressolve</TableCell>
                        <TableCell as="th">Datos cliente</TableCell>
                        <TableCell as="th">Valores posibles</TableCell>
                        <TableCell as="th">Nombre del audio</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {metadataMappings.map((mapping) => (
                        <TableRow key={mapping.id}>
                          <TableCell
                            colSpan="1"
                          >
                            <Input
                              id={`key-${mapping.id}`}
                              size="small"
                              defaultValue={mapping.key}
                              readOnly={['Cliente'].includes(Role)}
                              onClick={handleInputClick}
                              className='input-mapping'
                              style={{
                                color: 'black !important'
                              }}
                            />
                          </TableCell>
                          <TableCell
                            colSpan="1"
                          >
                            <Input
                              size="small"
                              id={`client-column-${mapping.id}`}
                              defaultValue={mapping.client_column}
                              readOnly={['Cliente'].includes(Role)}
                              onClick={handleInputClick}
                              className='input-mapping'
                              onChange={(e) => radioChangeReal(e.target.value, mapping)}
                            />
                          </TableCell>
                          <TableCell
                            colSpan="1"
                          >
                            <Input
                              size="small"
                              id={`possible-values-${mapping.id}`}
                              defaultValue={mapping.client_possible_values}
                              readOnly={['Cliente'].includes(Role)}
                              className='input-mapping'
                            />
                          </TableCell>
                          <TableCell
                          colSpan="3"
                          >
                            <div className='radio-option'>
                            
                            <Radio
                            value={mapping.key}
                            id={`column-name-audio-${mapping.id}`}
                            onChange={() => radioChange(mapping)}
                            checked={columnNameAudioId === mapping.id}
                            >
                            </Radio>
                            </div>
                          </TableCell>
                          <TableCell
                          >
                            <Button
                              variation="primary"
                              colorTheme="warning"
                              className='button-table'
                              title='Remover Proyecto a este usuario'
                              onClick={() => removeMapping(mapping.id)}
                              isDisabled={['Cliente'].includes(Role)}
                            >
                              <Icon
                                viewBox={{ width: 20, height: 20 }}
                                color="red"
                                as={MdOutlineRemoveCircleOutline} aria-hidden="true"
                              />
                            </Button>

                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
                {
                  columnNameAudio === '' ? (
                    <Message colorTheme="warning"><Text>Seleccione la columna que tiene el nombre de los audios</Text></Message>

                  ) : (
                    
                    <Message colorTheme="info"><Text>Columna con los nombre de los audios: <b>{columnNameAudio}</b></Text></Message>
                  )
                }
                {Role !== 'Cliente' && (
                  <div>
                    <button type="button" className="custom-button" onClick={addMapping}>Agregar Mapeo</button>
                    <button type="button" className="custom-button" onClick={saveMappings}>Guardar Información</button>
                  </div>
                )}
                <div className="file-input-container">
                  <label className="file-label" htmlFor="fileInput">
                    Seleccionar archivo
                  </label>
                  <input id="fileInput" type="file" onChange={handleFileChange} />
                  {file && <Text> <Badge
                    size="large"
                    variation="warning">
                    {file.name}
                  </Badge></Text>}
                </div>
                <button type="submit" className="custom-button">Subir</button>
              </div>
            </>
          )}
        </form>
      )}
      {uploadProgress > 0 && <p className="upload-progress">Progreso de subida: {uploadProgress.toFixed(2)}%</p>}
      {isValidating && <p className="validating-message">Esperando validación, esto puede tardar varios minutos dependiendo del tamaño del zip ...</p>}
      {adminMessage && (
        <p className="admin-message">{adminMessage}</p>
      )}
      <p className={`message ${message.includes('Error') ? 'error' : message.includes('exitosos') ? 'success' : message.includes('Estado') ? 'info' : ''}`}>{message}</p>
        </div>
      )}
 </div>
  );
}

export default UploadPage;
